<app-navbar></app-navbar>

<div class="container pt-lg-7">
  <div class="row justify-content-center">
    <div class="row">
      <div class="login-card shadow-lg animate__animated animate__fadeInUp">
        <!-- Header -->
        <div class="card-header  text-center text-white">
          <h1 class="m-0 main-font_light text-white">إعادة ضبط كلمة المرور</h1>
        </div>

        <!-- Body -->
        <div class="card-body px-lg-5 py-lg-5">
          <!-- Step 1: Send Code -->
          <div *ngIf="sendCodeStep" class="text-center text-login">
            <div class="text-login_welcome main-font_light mb-2">
              أدخل رقم هاتفك
            </div>
            <div class="text-login_desc">
              <small>الرجاء إدخال رقم هاتفك لتلقي رمز إعادة تعيين كلمة المرور</small>
            </div>

            <form class="login-form mt-4" role="form">
              <div class="form-group mb-4">
                <select
                  class="form-control text-center"
                  [(ngModel)]="selectedType"
                  [ngModelOptions]="{ standalone: true }"
                >
                  <option
                    *ngFor="let option of resetTypeOptions"
                    [value]="option.value"
                  >
                    {{ option.label }}
                  </option>
                </select>
              </div>

              <div class="form-group mb-4 position-relative">
                <label class="login-form_phone-code">{{ phoneCode }}</label>
                <input
                  type="text"
                  class="form-control text-center"
                  style="letter-spacing: 6px"
                  [(ngModel)]="phoneNumber"
                  pattern="\d*"
                  placeholder="رقم الهاتف"
                  [ngModelOptions]="{ standalone: true }"
                />
              </div>

              <button
                type="button"
                class="btn btn-primary w-100 py-3"
                (click)="sendCode()"
              >
                إرسال الرمز
              </button>
            </form>
          </div>

          <!-- Step 2: Verify Code -->
          <div *ngIf="verifyCodeStep" class="text-center text-login">
            <div class="text-login_welcome main-font_light mb-2">
              تحقق من الرمز
            </div>
            <div class="text-login_desc">
              <small>الرجاء إدخال رمز التحقق الذي أرسل إليك</small>
            </div>

            <form class="login-form mt-4" role="form">
              <div class="form-group mb-4">
                <input
                  type="text"
                  class="form-control text-center"
                  style="letter-spacing: 8px"
                  [(ngModel)]="resetCode"
                  pattern="\d*"
                  placeholder="رمز التحقق"
                  [ngModelOptions]="{ standalone: true }"
                />
              </div>

              <button
                type="button"
                class="btn btn-primary w-100 py-3"
                (click)="verifyCode()"
              >
                تحقق
              </button>
            </form>
          </div>

          <!-- Step 3: Reset Password -->
          <div *ngIf="resetPasswordStep" class="text-center text-login">
            <div class="text-login_welcome main-font_light mb-2">
              كلمة مرور جديدة
            </div>
            <div class="text-login_desc">
              <small>الرجاء إدخال كلمة المرور الجديدة الخاصة بك</small>
            </div>

            <form class="login-form mt-4" role="form" dir="rtl">
              <div class="form-group mb-3 text-start">
                <label>كلمة المرور الجديدة</label>
                <input
                  type="password"
                  class="form-control"
                  [(ngModel)]="password"
                  placeholder="********"
                  [ngModelOptions]="{ standalone: true }"
                />
              </div>

              <div class="form-group mb-4 text-start">
                <label>تأكيد كلمة المرور</label>
                <input
                  type="password"
                  class="form-control"
                  [(ngModel)]="confirmPassword"
                  placeholder="********"
                  [ngModelOptions]="{ standalone: true }"
                />
              </div>

              <button
                type="button"
                class="btn btn-primary w-100 py-3"
                (click)="resetPassword()"
              >
                تحديث كلمة المرور
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
